"use client";

import Image from "next/image";
import { Waves } from "lucide-react";
import { OpportunityCard } from "@/app/(app)/whale-watch/classic/desktop-opportunity-card";
import { DetailPanel } from "@/app/(app)/whale-watch/classic/desktop-detail-panel";
import { PRACTICE_WHALE } from "@/lib/marketing/whale-practice";
import type { MarketOpportunity, PeerOdds } from "@/lib/whale-watch/whale-watch-shared";
import styles from "./kalshi-practice-board.module.css";

export function WhalePracticeBoard({ selected, onSelect, onOpenTicket, opportunity = PRACTICE_WHALE, introduction = "The exchange footprint from the video: Florida International +4.5. These are fixed practice quotes; the matchup and date are illustrative." }: { selected: boolean; onSelect: () => void; onOpenTicket: () => void; opportunity?: MarketOpportunity<PeerOdds>; introduction?: string }) {
  return <div className={styles.whaleShell}>
    <div className={styles.appHeader}><Image src="/images/social/upside_logo.png" alt="Upside" width={84} height={32} className={styles.logo} /><span /><Waves size={20} /><strong>Whale Watch</strong><small>SEPARATE TOOL · SAMPLE DATA</small></div>
    <div className={styles.whaleIntro}>{introduction}</div>
    <div className={styles.whaleGrid} data-spotlight-context="whale">
      <div className={styles.whaleList} data-practice-target="whale-card" data-guided={!selected}>
        <span className={styles.whaleListLabel}>WHALE $ · HIGHEST FIRST</span>
        {!selected && <p className={styles.rowHint}>↓ Click this opportunity to inspect its posted orders.</p>}
        <OpportunityCard opp={opportunity} isSelected={selected} onSelect={onSelect} selectedBookKeys={["kalshi"]} practice />
        <p className={styles.whaleAside}>The large dollar amount is money supporting the price comparison. It is separate from how much you can buy at Kalshi’s current price.</p>
      </div>
      <div className={styles.whaleDetail}><DetailPanel opp={selected ? opportunity : null} selectedBookKeys={["kalshi"]} practice onPracticeBet={onOpenTicket} /></div>
    </div>
  </div>;
}
